if (document.getElementById('vue-logout')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: [ '[[', ']]' ],
		mixins: [ baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin ],
		el: '#vue-logout',
		mounted() {
			this.logout();
		},
		methods: {
			logout() {
				Cookies.remove('sessionid');
				localStorage.removeItem('user');
				this.post(window.site_url + '/api/v1/auth/logout/', {}, false, true)
					.then((response) => {
						Cookies.remove('csrftoken');
						localStorage.removeItem('token');
						setTimeout(() => {
							window.location = gettext('/fr');
						}, 3000);
					})
					.catch((error) => {
						// console.log(error);
						Cookies.remove('csrftoken');
						localStorage.removeItem('token');
						setTimeout(() => {
							window.location = gettext('/fr');
						}, 3000);
					});
			}
		}
	});
}
